import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@/components/ui/table";

interface KeyValueDetailsProps {
  properties: {
    [key: string]: any;
  };
  countText: string;
  header: string;
}

export const KeyValueDetails = (props: KeyValueDetailsProps) => {
  return (
    <div className="w-full">
      <p className="text-sm">{props.countText}</p>
      <h6 className="text-base font-semibold">{props.header}</h6>
      <Table>
        <TableBody>
          {Object.keys(props.properties).map((key) => (
            <TableRow key={key} className="border-0">
              <TableCell className="py-1">{key}</TableCell>
              <TableCell className="py-1">
                {props.properties[key] ? props.properties[key].toString() : ""}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
